module.exports = __webpack_public_path__ + "img/logo.728f26d8.png";